import React from "react";
import {
  Container,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CurrencyInput from "../common/CurrencyInput";
import ScrollToTopBtn from "../common/ScrollToTop";
import swal from "sweetalert";
import { toast } from "react-toastify";
import * as dataApi from "../../api/dataApi";

class Cost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      costs: [],
      member: "tff",
      years: [],
      year: "",
      month: "",
      cost: {},
      open: false,
      openEdit: false,
      errors: {},
      page: 0,
      rowsPerPage: 50,
      sortDirection: "desc",
    };
  }

  async componentDidMount() {
    try {
      this.getCosts();
      this.getYears();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getCosts = async () => {
    const { member, year, month } = this.state;
    const costs = await dataApi.getCosts(member, year, month);
    if (costs) {
      costs.sort((a, b) => new Date(b.operatingDate) - new Date(a.operatingDate));
    }
    this.setState({ costs: costs || [] });
  };

  getYears = async () => {
    const years = await dataApi.getYears(this.state.member);
    if (years) {
      this.setState({ years: years.reverse() });
    } else {
      this.setState({ years: [] });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChange = async (e) => {
    await this.setState({ [e.target.name]: e.target.value });
    this.getCosts();
  };

  handleOpen = () => {
    this.setState({ cost: {}, errors: {}, open: true });
  };

  handleOpenEdit = (item) => {
    const cost = {
      ...item,
      year: new Date(item.operatingDate).getFullYear(),
      month: new Date(item.operatingDate).getMonth() + 1,
    };
    this.setState({ cost, errors: {}, openEdit: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCloseEdit = () => {
    this.setState({ openEdit: false });
  };

  handleDialogChange = (e) => {
    const { name, value } = e.target;
    const cost = { ...this.state.cost, [name]: value };
    const errors = { ...this.state.errors, [name]: "" };
    this.setState({ cost, errors });
  };

  handleSave = async () => {
    if (!this.formIsValid()) return;
    this.setState({ open: false });

    let { year, month, amount } = this.state.cost;
    if (amount && typeof amount !== "number") {
      amount = parseFloat(amount.replace(/[.\s]/g, ""));
    }

    const response = await dataApi.newCost(this.state.member, year, month, amount);
    if (response) {
      this.getCosts();
      toast.success("Ny kostnad er lagret");
    } else {
      toast.error("Noe gikk galt...");
    }
  };

  handleSaveEdit = async () => {
    if (!this.formIsValid()) return;
    this.setState({ openEdit: false });

    let { year, month, amount } = this.state.cost;
    if (amount && typeof amount !== "number") {
      amount = parseFloat(amount.replace(/[.\s]/g, ""));
    }

    const response = await dataApi.updateCost(this.state.member, year, month, amount);
    if (response) {
      this.getCosts();
      toast.success("Kostnad er oppdatert");
    } else {
      toast.error("Noe gikk galt...");
    }
  };

  handleDeleteCost = (cost) => {
    swal({
      title: "Slette kostnad?",
      icon: "warning",
      buttons: ["Avbryt", "OK"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        const year = new Date(cost.operatingDate).getFullYear();
        const month = new Date(cost.operatingDate).getMonth() + 1;
        const response = await dataApi.deleteCost(this.state.member, year, month, cost.amount);
        if (response) {
          this.getCosts();
          swal("Kostnad er slettet!", { icon: "success" });
        } else {
          swal("Noe gikk galt", { icon: "error" });
        }
      }
    });
  };

  formIsValid = () => {
    const errors = {};
    if (!this.state.cost.year) errors.year = "Velg år";
    if (!this.state.cost.month) errors.month = "Velg måned";
    if (!this.state.cost.amount) errors.amount = "Fyll inn beløp";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  render() {
    const { costs, years, year, month, rowsPerPage, page, cost, open, openEdit, errors } = this.state;

    const layoutStyle = { width: "100%", paddingTop: 80, margin: "auto" };
    const paperStyle = { width: "100%", padding: 20 };
    const headStyle = { backgroundColor: "#eeeeee", fontWeight: "bold", fontSize: 16 };

    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layoutStyle}>
            <Paper style={paperStyle}>
              <CssBaseline />
              <Typography variant="h5" gutterBottom>
                Driftskostnader
              </Typography>
              <Grid container spacing={3}>
                {/* Organization, Year, and Month Filters */}
                <Grid item lg={2}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      name="member"
                      value={this.state.member}
                      onChange={this.handleChange}
                    >
                      <FormControlLabel
                        value="tff"
                        control={<Radio color="primary" />}
                        label="TFF"
                      />
                      <FormControlLabel
                        value="yff"
                        control={<Radio color="primary" />}
                        label="YFF"
                      />
                    </RadioGroup>
                  </FormControl>

                </Grid>
                <Grid item lg={2}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel>År</InputLabel>
                    <Select name="year" value={year || ""} onChange={this.handleChange}>
                      <MenuItem value="">Alle</MenuItem>
                      {years.map((yr, index) => (
                        <MenuItem key={index} value={yr}>
                          {yr}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={2}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel>Måned</InputLabel>
                    <Select name="month" value={month || ""} onChange={this.handleChange}>
                      <MenuItem value="">Alle</MenuItem>
                      {months.map((mo) => (
                        <MenuItem key={mo} value={mo}>
                          {mo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Add New Cost */}
                <Grid item lg={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxIcon />}
                    onClick={this.handleOpen}
                  >
                    Ny Kostnad
                  </Button>
                </Grid>
              </Grid>

              {/* Dialogs */}
              {/* Add Dialog */}
              <Dialog open={open} onClose={this.handleClose} fullWidth>
                <DialogTitle>Ny Kostnad</DialogTitle>
                <DialogContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField label="Organisasjon" value={this.state.member.toUpperCase()} fullWidth disabled />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel>År</InputLabel>
                        <Select
                          name="year"
                          value={cost.year || ""}
                          onChange={this.handleDialogChange}
                          error={Boolean(errors.year)}
                        >
                          {years.map((yr, index) => (
                            <MenuItem key={index} value={yr}>
                              {yr}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel>Måned</InputLabel>
                        <Select
                          name="month"
                          value={cost.month || ""}
                          onChange={this.handleDialogChange}
                          error={Boolean(errors.month)}
                        >
                          {months.map((mo) => (
                            <MenuItem key={mo} value={mo}>
                              {mo}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <CurrencyInput
                        name="amount"
                        placeholder="NOK 1.000"
                        value={cost.amount}
                        onChange={this.handleDialogChange}
                        includeThousandsSeparator
                        allowDecimal={false}
                        className="MuiInputBase-input MuiInput-input"
                      />
                      {errors.amount && (
                        <Typography color="error" variant="caption">
                          {errors.amount}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="secondary">
                    Avbryt
                  </Button>
                  <Button onClick={this.handleSave} color="primary">
                    Lagre
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Edit Dialog */}
              <Dialog open={openEdit} onClose={this.handleCloseEdit} fullWidth>
                <DialogTitle>Rediger Kostnad</DialogTitle>
                <DialogContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField label="Organisasjon" value={this.state.member.toUpperCase()} fullWidth disabled />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel>År</InputLabel>
                        <Select
                          name="year"
                          value={cost.year || ""}
                          onChange={this.handleDialogChange}
                          error={Boolean(errors.year)}
                        >
                          {years.map((yr, index) => (
                            <MenuItem key={index} value={yr}>
                              {yr}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel>Måned</InputLabel>
                        <Select
                          name="month"
                          value={cost.month || ""}
                          onChange={this.handleDialogChange}
                          error={Boolean(errors.month)}
                        >
                          {months.map((mo) => (
                            <MenuItem key={mo} value={mo}>
                              {mo}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <CurrencyInput
                        name="amount"
                        placeholder="NOK 1.000"
                        value={cost.amount}
                        onChange={this.handleDialogChange}
                        includeThousandsSeparator
                        allowDecimal={false}
                        className="MuiInputBase-input MuiInput-input"
                      />
                      {errors.amount && (
                        <Typography color="error" variant="caption">
                          {errors.amount}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleCloseEdit} color="secondary">
                    Avbryt
                  </Button>
                  <Button onClick={this.handleSaveEdit} color="primary">
                    Lagre
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Table */}
              <Paper style={{ marginTop: 20 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={headStyle}>Rediger</TableCell>
                      <TableCell style={headStyle}>År</TableCell>
                      <TableCell style={headStyle}>Måned</TableCell>
                      <TableCell style={headStyle} align="right">
                        Beløp
                      </TableCell>
                      <TableCell style={headStyle}>Slett</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {costs.length > 0 ? (
                      costs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((cost, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              onClick={() => this.handleOpenEdit(cost)}
                            >
                              Rediger
                            </Button>
                          </TableCell>
                          <TableCell>{new Date(cost.operatingDate).getFullYear()}</TableCell>
                          <TableCell>{new Date(cost.operatingDate).getMonth() + 1}</TableCell>
                          <TableCell align="right">{cost.amount.toLocaleString("nb-NO")}</TableCell>
                          <TableCell>
                            <Button
                              color="error"
                              startIcon={<DeleteForeverIcon />}
                              onClick={() => this.handleDeleteCost(cost)}
                            >
                              Slett
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          Ingen treff
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 50]}
                  component="div"
                  count={costs.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </Paper>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default Cost;
